import { IconButton, InputAdornment, Stack, TextField, Typography } from '@mui/material';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import GlobalTableGenerator from '../../../../../components/GlobalTableGenerator';
import { reassignLeadTableHeader } from '../utils/ReassignLeadTableHeader';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import { useDispatch } from 'react-redux';
import { getLeadDetails } from '../../../../../redux/features/ogdSlice';
import { useSelector } from 'react-redux';

const LeadDetailsSearchTable = () => {
  const [search, setSearch] = useState('');
  const dispatch = useDispatch();

  const ogdLeadDetails = useSelector((state) => state.ogd.ogdLeadDetails.data);
  const ogdLeadDetailsLoading = useSelector((state) => state.ogd.ogdLeadDetails.loading);
  const signlRef = useRef(null);

  const submitHandler = (e) => {
    e?.preventDefault?.();

    signlRef.current = dispatch(getLeadDetails({ search: typeof e === 'string' ? e : search }));
  };

  useEffect(() => {
    submitHandler({ search: '' });
    return () => {
      signlRef.current?.abort?.();
    };
  }, [dispatch]);

  return (
    <Stack mt={3} gap={1}>
      <Typography variant="h5">Search For Lead Details</Typography>
      <form onSubmit={submitHandler} style={{ alignSelf: 'self-end' }}>
        <TextField
          label="Email/Phone"
          onChange={(e) => setSearch(e.target.value)}
          value={search}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                {Boolean(search) && (
                  <IconButton
                    onClick={() => {
                      setSearch('');
                      submitHandler('');
                    }}
                  >
                    <ClearIcon />
                  </IconButton>
                )}
                <IconButton type="submit">
                  <SearchIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </form>
      <GlobalTableGenerator
        rows={Array.isArray(ogdLeadDetails) ? ogdLeadDetails : []}
        loading={ogdLeadDetailsLoading}
        columns={reassignLeadTableHeader}
        TableHeadStyle={{ bgcolor: '#cfc8c8ff' }}
        pagination
      />
    </Stack>
  );
};
export default React.memo(LeadDetailsSearchTable);
